import { Logger } from '../../utils/logger';
import { setDataToPocket } from '../../utils/pocket';

export async function getGeolocation() {
    try {
        const res = await fetch('https://websiteapi.acronis.com/geo/location/v1/ip/geolocation');
        const geo = await res.json();
        setDataToPocket('geo', geo);
    } catch (e) {
        Logger.error('Geolocation failed:', e);
    }
}
